export default __webpack_public_path__ + "82bc3975fc288e44f0fff1da925f530e.gif";